<script>
  import { createEventDispatcher } from 'svelte';
  import { mdiPause, mdiPlay } from "@mdi/js";
  import { Icon } from "@smui/icon-button";
  import { Transport } from 'tone';
  import ToneButton from "./ToneButton.svelte";

  export let started = false;
  export let disabled = false;

  const dispatch = createEventDispatcher();

  function handleClick(event){
    console.log(event);
    started = !started;
    started ? Transport.start() : Transport.stop();
    dispatch(started ? 'start' : 'stop');
  }
</script>

<div class="tonebutton" style="display: flex; justify-content: stretch;">
<ToneButton
  {disabled}
  on:changed={handleClick}
  aria-label={started ? 'Stop' : 'Start'}>
  <Icon tag="svg" viewBox="0 0 24 24">
    {#if started}
      <path fill="currentColor" d={mdiPause}/>
    {:else}
      <path fill="currentColor" d={mdiPlay}/>
    {/if}
  </Icon>
</ToneButton>
</div>
  <style lang="scss">
  @use "../theme/_smui-theme.scss";

  .tonebutton {
  }

</style>